<template>
  <router-view v-if="isLogin" />
  <div v-else class="fd-shell main-wrapper">
    <AppSidebar />
    <div class="fd-shell__main right-wrapper">
      <AppHeader />
      <main class="fd-shell__content right-sub-content" :class="moduleClass">
        <router-view v-slot="{ Component, route }">
          <template v-if="route.matched.length && Component">
            <component :is="Component" :key="route.path" />
          </template>
          <div v-else-if="route.matched.length" class="route-view-page-loading" role="status">
            <p>Loading page…</p>
          </div>
        </router-view>
      </main>
    </div>
  </div>
</template>

<script setup>
import { computed, onBeforeUnmount, watch } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import AppSidebar from "./AppSidebar.vue";
import AppHeader from "./AppHeader.vue";
import { provideSidebar } from "@app/composables/useSidebar";
import { resolveTenantIdFromBrowser } from "@/utils/tenant";
import { moduleClassForRoute } from "@app/config/modules";

const route = useRoute();
const store = useStore();
provideSidebar();

const moduleClass = computed(() => moduleClassForRoute(route.name));

const isLogin = computed(() => route.name === "Login");

let lastUserDataTenantId = null;

function ensureUserBootstrap() {
  if (!localStorage.getItem("authToken")) {
    lastUserDataTenantId = null;
    return;
  }
  const tenantId = resolveTenantIdFromBrowser();
  if (!tenantId) return;
  store.dispatch("tenantId/fetchTenants");
  if (lastUserDataTenantId === tenantId) return;
  lastUserDataTenantId = tenantId;
  store.dispatch("tenantId/getUserData");
}

watch(
  moduleClass,
  (cls, prev) => {
    const html = document.documentElement;
    if (prev) html.classList.remove(prev);
    if (cls) html.classList.add(cls);
  },
  { immediate: true }
);

onBeforeUnmount(() => {
  if (moduleClass.value) {
    document.documentElement.classList.remove(moduleClass.value);
  }
});

watch(() => route.fullPath, ensureUserBootstrap, { immediate: true });
</script>
